/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import ApplicationState        from 'g3w-state';
  import GUI                     from 'g3w-app';
  import { XHR }                 from 'utils/XHR';
  import { getCatalogLayerById } from 'utils/getCatalogLayerById';


  const __vue_script__ = {

    name: "modal-metadata",

    data() {
      const project = ApplicationState.project.getState();
      const layers  = Object.values(ApplicationState.layers).flatMap(s => s.showOnCatalog() ? s : [])
        .flatMap(s => s.showOnCatalog() ? s.getLayers() : [])
        // In case of layers that has geometry and no epsg, filter according to filter of project layers
        .filter(l => 'NoGeometry' === l.getGeometryType() || (l.config.crs && l.config.crs.epsg));

      // @since 4.1.0 set WMS URL if not set by QGIS project
      if (!project.metadata.wms_url) {
        project.metadata.wms_url = `${project.WMSUrl}?service=WMS&version=1.3.0&request=GetCapabilities`;
      } 

      // @since 4.1.0 set WMTS URL if not set by QGIS project
      if (!project.metadata.wmts_url) {
        project.metadata.wmts_url = `${project.WMSUrl}?service=WMTS&version=1.3.0&request=GetCapabilities`;
      } 

      // @since 4.1.0 check if exist a layer with wfs capability
      const wfs_layer = layers.find(l => l.isWfsActive?.());
      if (wfs_layer) {
        project.metadata.wfs_url  = `${project.WMSUrl}?service=WFS&version=1.3.0&request=GetCapabilities`;
        project.metadata.wfs3_url = `${project.WMSUrl}wfs3/`;
      }

      const version = window.initConfig.version.split('-')[0].split('.');
      return {
        open:          false, //@since 4.1.0 modal state
        customcredits: false,
        powered_by:    window.initConfig.powered_by,
        urls:          window.initConfig.urls,
        docs_url:      `https://g3w-suite.readthedocs.io/en/v${version[0].replace('v','')}.${version[1]}.x/`,
        g3wsdk_info:  '',
        project,
        layers,
        legendurls:   [],
      };
    },

    computed: {
      username() {
        return (window.initConfig?.user?.username ?? 'anonymous');
      },
    },

    methods: {

      /**
       * @returns layer legend url
       * 
       * @since 4.1.0
       */
      getLegendUrlById(id) {
        try {
          const layer = getCatalogLayerById(id);
          const url = new URL(layer.getLegendUrl(window.initConfig?.layout?.legend, { all: true }));
          url.searchParams.set('STYLES', layer.getCurrentStyle()?.name || '');
          // force black color for text
          if ('true' === url.searchParams.get('TRANSPARENT') && 'white' === url.searchParams.get('ITEMFONTCOLOR')) {
            url.searchParams.delete('ITEMFONTCOLOR');
          }
          // force black color for text
          if ('true' === url.searchParams.get('TRANSPARENT') && 'white' === url.searchParams.get('LAYERFONTCOLOR')) {
            url.searchParams.delete('LAYERFONTCOLOR');
          }
          url.searchParams.set('LAYERTITLE', 'false');
          return url.toString();
        } catch(e) {
          return ''; // fails silently
        }
      },

      /**
       * @since 4.1.0
       */
      getLegendUrl(url) {
        try {
          return (new URL(url)).toString();
        } catch(e) {
          return ''; // fails silently
        }
      },

      sanitizeValue(value) {
        if (Array.isArray(value) || ('object' === typeof value && null !== value)) {
          value = Object.values(value).length ? value : '';
        }
        return value;
      },

      copy_g3wsdk_info(e) {
        const range = document.createRange();
        range.selectNode(e.target);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        alert('Copied to clipboard!');
      },

      /**
       * @since 4.1.0
       */
      async onBeforetoggle(e) {
        this.open = 'open' === e.newState;
        if (this.open) {
          await Promise
                  .allSettled([
                    new Promise((resolve) => $script('https://unpkg.com/platform@1.3.6/platform.js', resolve)),
                    new Promise((resolve) => g3wsdk.core.ApplicationService.complete ? resolve() : g3wsdk.core.ApplicationService.on('complete', resolve))
                  ]);

                  /** @since 3.8.0 */
                  const platform = window.platform || {};

                  this.g3wsdk_info = `
          [g3wsdk.info]\n
          - g3w-admin: __${initConfig.version}__
          - g3w-client: __${process.env.g3w_client_rev}__
          ${Object.entries(window.initConfig.plugins).map((p) => (`    - ${p[0]}: __${p[1].version}__`)).join('\n')}
          - browser: __${platform.name} ${platform.version}__
          - operating system: __${platform.os.toString()}__
          `.trim();
        }
      },

    },

    async created() {
      if (!!window.initConfig.credits) {
        try {
          const credits      = await XHR.get({ url: window.initConfig.credits });
          this.customcredits = 'None' !== credits && credits;
        } catch(e) {
          console.warn(e);
        }
      }
    },

    mounted() {
      document.body.appendChild(this.$el);
      //Load legend layers url one time
      this.$el.querySelector('li a[href="#metadata_legend"]').addEventListener('click', async () => {
        if (0 === this.legendurls.length) {
          //clone legend config
          const olegend = { ...(window.initConfig?.layout?.legend || {}) };
          // force black color for text
          if (olegend.transparent && (!olegend.color || 'white' === olegend.color)) {
            window.initConfig.layout.legend.color = 'black'; //set black
          }
          if (!olegend.layertitle) {
            window.initConfig.layout.legend.layertitle = true;
          }
          this.legendurls = await GUI.getLegendSrc({ all: true });
          window.initConfig.layout.legend = olegend; // restore legend config
        }
      })
    },

  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{staticStyle:{"width":"80vw"},attrs:{"id":"modal-metadata","aria-label":_vm.$t('Metadata')},on:{"beforetoggle":_vm.onBeforetoggle}},[_c('form',{attrs:{"method":"dialog"}},[_c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"active"},[_c('a',{staticClass:"metadata-item-tab general",staticStyle:{"color":"var(--skin-primary)"},attrs:{"data-toggle":"tab","href":"#metadata_general"}},[_c('i',{staticClass:"fas fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('GENERAL')))])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"metadata-item-tab layers",staticStyle:{"color":"var(--skin-warning)"},attrs:{"data-toggle":"tab","href":"#metadata_layers"}},[_c('i',{staticClass:"fas fa-layer-group",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('data').toUpperCase()))])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"metadata-item-tab legend",staticStyle:{"color":"purple"},attrs:{"data-toggle":"tab","href":"#metadata_legend"}},[_c('i',{staticClass:"fas fa-list",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('legend').toUpperCase()))])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"metadata-item-tab credits",attrs:{"data-toggle":"tab","href":"#metadata_credits"}},[_c('i',{staticClass:"fa fa-copyright",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('Credits')))])])])]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"65vh","max-height":"70vh","padding":"15px","overflow":"auto"}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"metadata_general"}},[_c('table',{staticStyle:{"width":"100%"}},[_c('tbody',[(_vm.project.metadata.title)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('TITLE')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value",domProps:{"innerHTML":_vm._s(_vm.project.metadata.title)}})]):_vm._e(),_vm._v(" "),(_vm.project.metadata.name)?_c('tr',{staticStyle:{"display":"none !important"}},[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value",domProps:{"innerHTML":_vm._s(_vm.project.metadata.name)}})]):_vm._e(),_vm._v(" "),(_vm.project.metadata.description)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('DESCRIPTION')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value",domProps:{"innerHTML":_vm._s(_vm.project.metadata.description)}})]):_vm._e(),_vm._v(" "),(_vm.project.metadata.abstract)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('ABSTRACT')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value",domProps:{"innerHTML":_vm._s(_vm.project.metadata.abstract)}})]):_vm._e(),_vm._v(" "),(_vm.project.metadata.contactinformation)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('CONTACTS')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[((_vm.project.metadata.contactinformation.personprimary || {}).contactperson || (_vm.project.metadata.contactinformation.personprimary || {}).ContactPerson)?_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('i',{staticClass:"fas fa-user-tie",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Person')))]),_vm._v("\n                    "+_vm._s((_vm.project.metadata.contactinformation.personprimary || {}).contactperson || (_vm.project.metadata.contactinformation.personprimary || {}).ContactPerson)+"\n                  ")]):_vm._e(),_vm._v(" "),((_vm.project.metadata.contactinformation.personprimary || {}).contactorganization || (_vm.project.metadata.contactinformation.personprimary || {}).ContactOrganization)?_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('i',{staticClass:"fa fa-building",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Organization')))]),_vm._v("\n                    "+_vm._s((_vm.project.metadata.contactinformation.personprimary || {}).contactorganization || (_vm.project.metadata.contactinformation.personprimary || {}).ContactOrganization)+"\n                  ")]):_vm._e(),_vm._v(" "),((_vm.project.metadata.contactinformation.personprimary || {}).contactposition || (_vm.project.metadata.contactinformation.personprimary || {}).ContactPosition)?_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('i',{staticClass:"fas fa-sitemap",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Role')))]),_vm._v("\n                    "+_vm._s((_vm.project.metadata.contactinformation.personprimary || {}).contactposition || (_vm.project.metadata.contactinformation.personprimary || {}).ContactPosition)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.project.metadata.contactinformation.contactelectronicmailaddress)?_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('i',{staticClass:"fas fa-envelope",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Email')))]),_vm._v(" "),_c('a',{attrs:{"href":("mailto: " + (_vm.sanitizeValue(_vm.project.metadata.contactinformation.contactelectronicmailaddress)))}},[_vm._v("\n                      "+_vm._s(_vm.sanitizeValue(_vm.project.metadata.contactinformation.contactelectronicmailaddress))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.contactinformation.contactvoicetelephone)?_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('i',{staticClass:"fas fa-mobile",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Phone')))]),_vm._v(" "),_c('a',{attrs:{"href":("tel: " + (_vm.sanitizeValue(_vm.project.metadata.contactinformation.contactvoicetelephone)))}},[_vm._v("\n                      "+_vm._s(_vm.sanitizeValue(_vm.project.metadata.contactinformation.contactvoicetelephone))+"\n                    ")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.project.modified || _vm.project.qgis_version)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('LAST MODIFIED')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[(_vm.project.modified)?[_c('i',{staticClass:"far fa-clock",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s((new Date(_vm.project.modified * 1000)).toISOString())+"\n                  ")]:_vm._e(),_vm._v(" "),(_vm.project.qgis_version)?[_c('i',{staticClass:"fas fa-code-branch",staticStyle:{"margin-right":"3px","margin-left":"1ch"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{attrs:{"href":'https://docs.qgis.org/'+_vm.project.qgis_version.split('.').slice(0, 2).join('.'),"target":"_blank","title":"QGIS version","data-placement":"right"}},[_vm._v("\n                      "+_vm._s(_vm.project.qgis_version)+"\n                    ")])]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.project.metadata.keywords && _vm.project.metadata.keywords.length)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('KEYWORDS')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"fas fa-tags",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s([].concat(_vm.project.metadata.keywords).join(', ')))])])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.fees)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('FEES')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"fas fa-shopping-cart",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.project.metadata.fees))])])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.accessconstraints)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('ACCESS CONSTRAINT')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"far fa-copyright",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.project.metadata.accessconstraints))])])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.wms_url)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('WMS')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"far fa-image",staticStyle:{"margin-right":"3px"}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.project.metadata.wms_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.project.metadata.wms_url))])])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.wmts_url)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('WMTS')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"far fa-image",staticStyle:{"margin-right":"3px"}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.project.metadata.wmts_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.project.metadata.wmts_url))])])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.wfs_url)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('WFS')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"fas fa-layer-group",staticStyle:{"margin-right":"3px"}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.project.metadata.wfs_url,"target":"_blank","title":_vm.layers.filter(function (l) { return l.isWfsActive(); }).map(function (l) { return l.getName(); }).join('<br>')}},[_vm._v(_vm._s(_vm.project.metadata.wfs_url)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.project.metadata.wfs_url)?_c('tr',[_c('td',{staticClass:"col-sm-2 label"},[_vm._v(_vm._s(_vm.$t('WFS3')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"fas fa-layer-group",staticStyle:{"margin-right":"3px"}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.project.metadata.wfs3_url,"target":"_blank","title":_vm.layers.filter(function (l) { return l.isWfsActive(); }).map(function (l) { return l.getName(); }).join('<br>')}},[_vm._v(_vm._s(_vm.project.metadata.wfs3_url)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.project.crs)?_c('tr',[_c('td',{staticClass:"col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('EPSG')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-12 value"},[_c('dl',{staticStyle:{"gap":"0"}},[_vm._l((Object.keys(_vm.project.crs)),function(key,index){return [_c('dt',{staticClass:"col-sm-2"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('dd',{staticClass:"col-sm-10"},[('epsg' === key)?[_c('i',{staticClass:"fas fa-globe",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{attrs:{"href":("https://epsg.io/" + ((_vm.project.crs.epsg || '').toLowerCase().replace('epsg:', ''))),"target":"_blank","title":"Docs"}},[_c('b',[_vm._v(_vm._s(_vm.project.crs.epsg))])])]:[_vm._v(_vm._s(_vm.project.crs[key]))]],2)]})],2)])]):_vm._e(),_vm._v(" "),(_vm.project.extent)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('BBOX')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value",staticStyle:{"display":"flex","gap":"20px"}},_vm._l((Object.keys(_vm.project.extent)),function(key,index){return _c('span',[_c('b',[_vm._v(_vm._s((['minx', 'miny', 'maxx', 'maxy'])[index]))]),_vm._v(" "+_vm._s(_vm.project.extent[key])+"\n                  ")])}),0)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"metadata_layers"}},_vm._l((_vm.layers),function(layer){return _c('details',{attrs:{"hidden":layer.isBaseLayer()}},[_c('summary',[_c('i',{class:('NoGeometry' === layer.getGeometryType() ? 'fas fa-table' : 'fas fa-draw-polygon'),staticStyle:{"margin-right":"10px","color":"#999"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(layer.getName()))])]),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs layer-nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"active spatial-tab",attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":("#layer_general_" + (layer.getId())),"aria-controls":"general","role":"tab","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.$t('GENERAL')))])]),_vm._v(" "),('NoGeometry' !== layer.getGeometryType())?_c('li',{staticClass:"legend-tab",attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":("#layer_legend_" + (layer.getId())),"aria-controls":"legend","role":"tab","data-toggle":"tab"}},[_vm._v(" "+_vm._s(_vm.$t('legend').toUpperCase()))])]):_vm._e(),_vm._v(" "),(layer.config.metadata && layer.config.metadata.attributes && layer.config.metadata.attributes.length)?_c('li',{staticClass:"attributes-tab",attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":("#layer_attributes_" + (layer.getId())),"aria-controls":"attributes","role":"tab","data-toggle":"tab"}},[_vm._v(" "+_vm._s(_vm.$t('ATTRIBUTES')))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content layer-tab-content"},[_c('div',{staticClass:"tab-pane active",staticStyle:{"padding":"0 15px"},attrs:{"role":"tabpanel","id":("layer_general_" + (layer.getId()))}},[_c('table',{staticStyle:{"width":"100%"}},[_c('tbody',[(layer.config.name)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.config.name))])]):_vm._e(),_vm._v(" "),(layer.config.metadata && layer.config.metadata.title && layer.config.name !== layer.config.metadata.title)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('TITLE')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.config.metadata.title))])]):_vm._e(),_vm._v(" "),(layer.config.metadata && layer.config.metadata.abstract)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('ABSTRACT')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value",domProps:{"innerHTML":_vm._s(layer.config.metadata.abstract)}})]):_vm._e(),_vm._v(" "),(layer.config.source)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('SOURCE')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value"},[_c('i',{staticClass:"fas fa-database",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(layer.config.source.type))])]):_vm._e(),_vm._v(" "),(layer.config.metadata && layer.config.metadata.keywords)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('KEYWORDS')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value"},[_c('i',{staticClass:"fas fa-tags",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(layer.config.metadata.keywords.join(', ')))])]):_vm._e(),_vm._v(" "),(layer.config.metadata)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('ID')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value"},[_c('i',{staticClass:"fas fa-key",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(layer.getId()))])]):_vm._e(),_vm._v(" "),(layer.getGeometryType())?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('GEOMETRY')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"fas fa-shapes",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(layer.getGeometryType()))])]):_vm._e(),_vm._v(" "),(layer.getRelations().getArray().length)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('RELATIONS')))]),_vm._v(" "),_c('td',{staticClass:"col-md-10 col-sm-12 value"},[_c('i',{staticClass:"fas fa-sitemap",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(layer.getRelations().getArray().map(function (r) { return r.state.name; }).join(' - ')))])]):_vm._e(),_vm._v(" "),(layer.config.crs && 'NoGeometry' !== layer.getGeometryType())?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('EPSG')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('i',{staticClass:"fas fa-globe",staticStyle:{"margin-right":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{attrs:{"href":("https://epsg.io/" + ((layer.config.crs.epsg || '').toLowerCase().replace('epsg:', ''))),"target":"_blank","title":"Docs"}},[_c('b',[_vm._v(_vm._s(layer.config.crs.epsg))])])])]):_vm._e(),_vm._v(" "),(layer.config.metadata && layer.config.metadata.crs && layer.config.metadata.crs.length && 'NoGeometry' !== layer.getGeometryType())?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('CRS')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},_vm._l((layer.config.metadata.crs),function(crs){return _c('div',[_c('span',[_vm._v(_vm._s(crs))])])}),0)]):_vm._e(),_vm._v(" "),(layer.config.bbox)?_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('BBOX')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value",staticStyle:{"display":"flex","gap":"20px"}},_vm._l((layer.config.bbox),function(value,key){return _c('span',[_c('b',{staticStyle:{"margin-right":"5px"}},[_vm._v(_vm._s(key))]),_vm._v(" "+_vm._s(value)+"\n                        ")])}),0)]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"col-md-2 col-sm-12 label"},[_vm._v(_vm._s(_vm.$t('CAPABILITIES')))]),_vm._v(" "),_c('td',{staticClass:"col-sm-10 value"},[_c('span',{staticClass:"fa-stack",staticStyle:{"vertical-align":"top"},attrs:{"title":_vm.$t('VISIBILITY RANGE') + ': ' + layer.config.maxscale + ' ÷ ' + layer.config.minscale}},[_c('i',{staticClass:"fas fa-eye fa-stack-1x",attrs:{"aria-label":layer.state.geolayer}}),_vm._v(" "),(!layer.state.geolayer)?_c('i',{staticClass:"fas fa-ban fa-stack-2x",staticStyle:{"color":"rgba(255, 99, 71, .7)"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"fa-stack",staticStyle:{"vertical-align":"top"},attrs:{"title":_vm.$t('EDITABLE')}},[_c('i',{staticClass:"fas fa-pencil-alt fa-stack-1x",attrs:{"aria-label":layer.isEditable()}}),_vm._v(" "),(!layer.isEditable())?_c('i',{staticClass:"fas fa-ban fa-stack-2x",staticStyle:{"color":"rgba(255, 99, 71, .7)"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"fa-stack",staticStyle:{"vertical-align":"top"},attrs:{"title":_vm.$t('FILTERABLE')}},[_c('i',{staticClass:"fas fa-filter fa-stack-1x",attrs:{"aria-label":layer.isFilterable()}}),_vm._v(" "),(!layer.isFilterable())?_c('i',{staticClass:"fas fa-ban fa-stack-2x",staticStyle:{"color":"rgba(255, 99, 71, .7)"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"fa-stack",staticStyle:{"vertical-align":"top"},attrs:{"title":_vm.$t('QUERYABLE')}},[_c('i',{staticClass:"fas fa-info fa-stack-1x",attrs:{"aria-label":layer.isQueryable()}}),_vm._v(" "),(!layer.isQueryable())?_c('i',{staticClass:"fas fa-ban fa-stack-2x",staticStyle:{"color":"rgba(255, 99, 71, .7)"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"fa-stack",staticStyle:{"vertical-align":"top"},attrs:{"title":_vm.$t('STYLES') + ': ' + (layer.config.styles || []).map(function (s) { return s.name; }).join(', ')}},[_c('i',{staticClass:"fas fa-paint-brush fa-stack-1x",attrs:{"aria-label":layer.config.styles && layer.config.styles.length > 1}}),_vm._v(" "),(!(layer.config.styles && layer.config.styles.length > 1))?_c('i',{staticClass:"fas fa-ban fa-stack-2x",staticStyle:{"color":"rgba(255, 99, 71, .7)"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"fa-stack",staticStyle:{"vertical-align":"top"},attrs:{"title":_vm.$t('DOWNLOAD FORMATS') + ': ' + layer.getDownloadFormats().join(', ')}},[_c('i',{staticClass:"fas fa-download fa-stack-1x",attrs:{"aria-label":layer.getDownloadFormats().length > 0}}),_vm._v(" "),(!layer.getDownloadFormats().length)?_c('i',{staticClass:"fas fa-ban fa-stack-2x",staticStyle:{"color":"rgba(255, 99, 71, .7)"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"1em"}},[_c('b',{staticStyle:{"color":"rgba(255, 99, 71, 1)"}},[_vm._v(_vm._s(_vm.$t('Restrictions applied to user'))+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.username))])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:('NoGeometry' !== layer.getGeometryType() && _vm.open),expression:"'NoGeometry' !== layer.getGeometryType() && open"}],staticClass:"tab-pane",attrs:{"role":"tabpanel","id":("layer_legend_" + (layer.getId()))}},[_c('img',{attrs:{"src":_vm.getLegendUrlById(layer.getId())}})]),_vm._v(" "),(layer.config.metadata && layer.config.metadata.attributes && layer.config.metadata.attributes.length)?_c('div',{staticClass:"tab-pane",staticStyle:{"padding":"0 15px"},attrs:{"role":"tabpanel","id":("layer_attributes_" + (layer.getId()))}},[_c('table',{staticClass:"table table-striped",staticStyle:{"background-color":"#eee !important"}},[_c('thead',[_c('tr',_vm._l((layer.config.metadata.attributes[0]),function(value,header){return _c('th',[_vm._v(_vm._s(header))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((layer.config.metadata.attributes),function(attr){return _c('tr',_vm._l((attr),function(value,header){return _c('td',[_vm._v(_vm._s(value))])}),0)}),0)])]):_vm._e()])])}),0),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"metadata_legend"}},[_c('b',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.$t('legend').toUpperCase()))]),_vm._v(" "),_vm._l((_vm.legendurls),function(url){return _c('div',{key:url.url},[_c('bar-loader',{attrs:{"loading":url.loading}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.getLegendUrl(url.url),"loading":"lazy","alt":""},on:{"load":function($event){url.loading = false},"loaderror":function($event){url.loading = false}}}),_vm._v(" "),_c('hr')],1)})],2),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"metadata_credits"}},[(!!_vm.customcredits)?_c('div',{staticClass:"customcredits",domProps:{"innerHTML":_vm._s(_vm.customcredits)}}):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{staticClass:"g3w-credits-block"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('Application based on OS framework'),expression:"'Application based on OS framework'"}],staticClass:"credit-title-logo",staticStyle:{"padding":"5px"}}),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://g3wsuite.it/"}},[_c('img',{staticClass:"g3w-suite-logo",attrs:{"src":((_vm.urls.clienturl) + "images/g3wsuite_logo.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('Publish and manage your QGIS projects on the web'),expression:"'Publish and manage your QGIS projects on the web'"}],staticStyle:{"margin-top":"10px"}})]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{directives:[{name:"t",rawName:"v-t:pre",value:('Framework developed by'),expression:"'Framework developed by'",arg:"pre"}],staticClass:"credit-title-logo g3w-credits-block",staticStyle:{"font-size":"1em","display":"flex","justify-content":"center"}},[_c('a',{staticStyle:{"text-align":"center!important"},attrs:{"href":"http://www.gis3w.it","target":"_blank"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"auto","display":"block","margin-right":"auto"},attrs:{"width":"60","src":((_vm.urls.clienturl) + "images/logo_gis3w_156_85.png"),"alt":""}})])]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('address',{staticStyle:{"line-height":"1.3","text-align":"center","margin-top":"5px","display":"flex","justify-content":"center","gap":"5px"},attrs:{"id":"address-credits"}},[_c('span',[_vm._v("📍 Montecatini Terme - Italy")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"tel:+393938534336"}},[_vm._v("📱 +39 393 8534336")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"mailto:info@gis3w.it"}},[_vm._v("✉️ info@gis3w.it")])]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","gap":"20px"}},[_c('a',{attrs:{"href":_vm.docs_url,"rel":"nofollow","target":"_blank"}},[_vm._v("📖 Docs")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@gis3w.it?subject=Sponsoring%20G3W-SUITE%20development&body=Hi%20there,%20I'd%20like%20to%20fund%20some%20code%20changes:"}},[_vm._v("❤️ Sponsor")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/g3w-suite","target":"_blank"}},[_vm._v("🐞 Report a bug")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.powered_by && _vm.g3wsdk_info)?_c('pre',{staticStyle:{"cursor":"pointer"},attrs:{"title":"click to copy"},on:{"click":_vm.copy_g3wsdk_info}},[_vm._v(_vm._s(_vm.g3wsdk_info))]):_vm._e()])])]),_vm._v(" "),_c('menu',{staticStyle:{"display":"flex","justify-content":"end"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-secondary",attrs:{"type":"cancel"}})])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-11914d32_0", { source: ".nav[role=tablist][data-v-11914d32]{display:flex;gap:1px;justify-content:space-between}.nav[role=tablist] li[data-v-11914d32]{background-color:#e4e4e4;width:100%}.nav[role=tablist] li.active[data-v-11914d32]{background-color:#fff}.nav[role=tablist] li.active a.metadata-item-tab[data-v-11914d32]{border-bottom-color:var(--bgcolor)!important;border-bottom-width:4px;background-color:transparent!important;color:#2c3b41!important}.nav[role=tablist] li a.metadata-item-tab[data-v-11914d32]{height:100%;margin:0;font-size:1.1em;border-top:0;border-right:0;border-left:0;border-bottom:4px solid #e2e2e2}.nav[role=tablist] li a[data-v-11914d32]{text-align:center}.nav[role=tablist] li a i[data-v-11914d32]{margin-right:5px}.metadata-item-tab[data-v-11914d32]{margin-right:10px;margin-bottom:10px}.tab-title[data-v-11914d32]{position:absolute;bottom:10px;right:auto}.tab-pane>table>tbody>tr[data-v-11914d32]{margin:0!important;padding-top:10px;padding-bottom:10px;border-bottom:1px solid #eee}.nav-tabs[data-v-11914d32]{border-bottom:0 none}.label[data-v-11914d32]{font-weight:700;font-size:1.1em;color:unset;text-align:unset;line-height:unset;padding:unset;white-space:unset}#metadata_layers>details>summary[data-v-11914d32]{border-bottom:1px solid #eee}#metadata_layers>details>summary[data-v-11914d32]{cursor:pointer;font-size:18px;position:relative;padding:20px 0}#metadata_layers>details>summary[data-v-11914d32]::marker{content:\"\"}#metadata_layers>details>summary[data-v-11914d32]::after{content:'+';float:right;font-weight:700;font-size:25px;margin-top:-4px}#metadata_layers>details[open]>summary[data-v-11914d32]::after{content:'-'}.layer-nav-tabs[data-v-11914d32]{border-bottom:0 solid #ddd}.layer-nav-tabs>li.active>a[data-v-11914d32],.layer-nav-tabs>li.active>a[data-v-11914d32]:focus,.layer-nav-tabs>li.active>a[data-v-11914d32]:hover{border-width:0}.layer-nav-tabs>li>a[data-v-11914d32]{border:none;color:#aeaeae}.layer-nav-tabs>li.active>a[data-v-11914d32],.layer-nav-tabs>li>a[data-v-11914d32]:hover{border:none;background:0 0}.layer-nav-tabs>li>a[data-v-11914d32]::after{content:\"\";height:2px;position:absolute;width:100%;left:0;bottom:-1px;transition:all 250ms ease 0s;transform:scale(0)}.layer-nav-tabs>li.active>a[data-v-11914d32]::after,.layer-nav-tabs>li:hover>a[data-v-11914d32]::after{transform:scale(1)}.layer-tab-content[data-v-11914d32]{margin-top:10px;overflow:auto}.attributes-tab[data-v-11914d32],.legend-tab[data-v-11914d32],.spatial-tab[data-v-11914d32]{font-weight:700}.layer-nav-tabs>li.active>a[data-v-11914d32],.layer-nav-tabs>li>a[data-v-11914d32]:hover{color:var(--skin-color)!important}.layer-nav-tabs>li>a[data-v-11914d32]::after{background:var(--skin-color)}.credit-title-logo[data-v-11914d32]{font-weight:700;font-size:1.2em;margin-bottom:15px}.g3w-credits-block[data-v-11914d32]{text-align:center!important;margin-bottom:20px}.g3w-suite-logo[data-v-11914d32]{width:50%!important}.customcredits[data-v-11914d32]{margin-bottom:10px;margin-top:5px;text-align:center}#metadata_general dt[data-v-11914d32]{font-weight:700}#metadata_general[data-v-11914d32] :is(dt,dd){margin:0;padding:.5em}@media (max-width:767px){#modal-metadata>form>.nav-tabs[data-v-11914d32]{display:none}}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-11914d32"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ModalMetadata.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__